package ui.uiAdminProfile

import react.*
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.main
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.p
import kotlinx.browser.window
import routes.EnumRoutes
import ui.components.CloseIcon
import ui.components.DashboardIcon
import ui.components.DataSidebarMenu
import ui.components.InquiriesIcon
import ui.components.ListingsIcon
import ui.components.MenuIcon
import ui.components.NavBar
import ui.components.OwnerSubmissionsIcon
import ui.components.ScheduleIcon
import ui.components.SettingsIcon
import ui.components.ShieldPersonIcon
import web.cssom.ClassName


external interface AdminProfileProps : Props{

}

val PageAdminProfile = FC<AdminProfileProps> {

    div {
        className = ClassName("min-h-screen bg-white flex relative")

        // Navigation
        NavBar{
//            this.activeNavItem = "Properties"
            this.sidebarItemsList = arrayListOf(
                DataSidebarMenu(
                    icon = createElement(DashboardIcon),
                    label = "Dashboard",
                    to = EnumRoutes.Dashboard.routeID,

                    ),
                DataSidebarMenu(
                    icon = createElement(ListingsIcon),
                    label = "Properties",
                    to = EnumRoutes.Properties.routeID
                ),
                DataSidebarMenu(
                    icon = createElement(OwnerSubmissionsIcon),
                    label = "Owner Submissions",
                    to = EnumRoutes.OwnerSubmissions.routeID
                ),
                DataSidebarMenu(
                    icon = createElement(InquiriesIcon),
                    label = "Inquiries",
                    to = EnumRoutes.PropertyInquiries.routeID),
                DataSidebarMenu(
                    icon = createElement(ScheduleIcon),
                    label = "Visit Scheduler",
                    to = EnumRoutes.ScheduledVisit.routeID
                ))
        }
        // Main Content
        div {
            className = ClassName("flex-1 p-6 lg:px-48")

            // Page Title
            h1 {
                className = ClassName("text-2xl text-[#7F161B] mb-2")
                +"Profile Overview"
            }

            // Profile Cards Section
            div {
                className = ClassName("flex gap-3 mb-8")

                // Administrator Card
                div {
                    className = ClassName("flex-1 bg-[#FFF4F4] rounded-lg p-5 flex flex-col gap-3")

                    div {
                        className = ClassName("relative")
                        div {
                            className = ClassName("w-8 h-8 bg-[#FFEAEA] rounded-full")
                        }
                        div {
                            className = ClassName("absolute top-[6px] left-[6px]")
                            ShieldPersonIcon {
                                className = "text-[#7F161B]"
                            }
                        }
                    }

                    p {
                        className = ClassName("text-sm font-normal")
                        +"Administrator"
                    }

                    h2 {
                        className = ClassName("text-2xl font-normal")
                        +"Admin User"
                    }

                    p {
                        className = ClassName("text-sm font-['Century_Schoolbook']")
                        +"You will have full access to manage listings, submissions and platform settings."
                    }
                }

                // Account Settings Card
                div {
                    className = ClassName("flex-1 bg-[#FFF4F4] rounded-lg p-5 flex flex-col gap-3")

                    div {
                        className = ClassName("relative")
                        div {
                            className = ClassName("w-8 h-8 bg-[#FFEAEA] rounded-full")
                        }
                        div {
                            className = ClassName("absolute top-[6px] left-[6px]")
                            SettingsIcon {
                                className = "text-[#7F161B]"
                            }
                        }
                    }

                    h2 {
                        className = ClassName("text-2xl font-normal")
                        +"Account Settings"
                    }

                    p {
                        className = ClassName("text-sm font-['Century_Schoolbook']")
                        +"Update your profile, change password and manage security."
                    }

                    // Action Buttons
                    div {
                        className = ClassName("flex gap-3")

                        button {
                            onClick = { window.location.href = "/admin-profile/edit" }
                            className = ClassName("flex-1 bg-[#7F161B] text-white rounded-lg px-4 py-3 text-sm font-['Century_Schoolbook']")
                            +"Edit Profile"
                        }

                        button {
                            onClick = { window.location.href = "/admin-profile/change-password" }
                            className = ClassName("flex-1 bg-[#FFEAEA] text-[#7F161B] rounded-lg px-4 py-3 text-sm font-['Century_Schoolbook']")
                            +"Change Password"
                        }
                    }
                }
            }

            // Contact Information Section
            h2 {
                className = ClassName("text-2xl font-normal mb-4")
                +"Contact Information"
            }

            div {
                className = ClassName("flex gap-3 mb-8")

                // Email
                div {
                    className = ClassName("flex-1")
                    p {
                        className = ClassName("text-sm font-normal mb-3")
                        +"Email"
                    }
                    div {
                        className = ClassName("bg-[#F8F8F7] rounded-lg px-4 py-3")
                        p {
                            className = ClassName("text-sm text-[#949494] font-['Century_Schoolbook']")
                            +"admin@boonconsultancy.com"
                        }
                    }
                }

                // Phone
                div {
                    className = ClassName("flex-1")
                    p {
                        className = ClassName("text-sm font-normal mb-3")
                        +"Phone"
                    }
                    div {
                        className = ClassName("bg-[#F8F8F7] rounded-lg px-4 py-3")
                        p {
                            className = ClassName("text-sm text-[#949494] font-['Century_Schoolbook']")
                            +"+1 234 567 890"
                        }
                    }
                }
            }

            // Admin Actions Section
            h2 {
                className = ClassName("text-2xl font-normal mb-4")
                +"Admin Actions"
            }

            button {
                className = ClassName("bg-[#7F161B] text-[#FFEAEA] rounded-lg px-5 py-3 text-sm font-['Century_Schoolbook']")
                +"Log Out"
            }
        }
    }
}
